import React from 'react';
import StyledSection from '../styles/StyledSection';

interface ContentSectionProps {
  children: React.ReactNode;
  tone?: 'default' | 'tone1' | 'tone2' | 'tone3';
  mb?: string | number;
  additionalClassName?: string;
  withBorder?: boolean;
}

/**
 * Common content section wrapper used by FundOpportunityEOI and FullContentDiffViewer
 * to ensure consistent content styling
 */
const ContentSection: React.FC<ContentSectionProps> = ({
  children,
  tone = 'tone1',
  mb = '4',
  additionalClassName = 'content-management-container',
  withBorder = false,
}) => {
  return (
    <StyledSection
      tone={tone}
      mb={mb}
      additionalClassName={additionalClassName}
      withBorder={withBorder}
    >
      {children}
    </StyledSection>
  );
};

export default ContentSection;
